import { useEffect, useState } from "react";

import ReportType from "./ReportType";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useLazyExportAutoVsManualReportDataQuery, useSearchAutoVsManualReportApiQuery } from "../report";
import { useLazyGetAllCountyByStateAbbrQuery } from "../../../data/counties/countiesApi";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import { useGetAllTenantsQuery } from "../../../customer/tenantApi";
import { getCurrentMonthStartDate, getStateValueFromParam } from "../../../../helpers/utils/Utils";

const AutoVsManualReport = () => {

    const tenantData = useGetAllTenantsQuery("");
    const [type, setType] = useState('AUTO_VS_MANUAL_REPORT');
    const [triggerExportReportDataQuery] = useLazyExportAutoVsManualReportDataQuery();
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()
    const stateDataApi = useGetAllStatesQuery("");
    const state = getStateValueFromParam(window);
    const formattedStartDate = getCurrentMonthStartDate();


    useEffect(() => {
        document.title = 'Reports';
    });

    useEffect(() => {
        getAllCountyByStateAbbrApi(state);
    }, [state]);
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Auto Vs Manual Report", url: "" }]
    )


    const columns: DataTableColumn[] = [
        {
            label: "Product",
            accessor: "product",
            overrideSortColumn: "product",
            canSort: false,
            visibility: { hasShowSetting: true },
            filterOptions: [{
                dependentColumns: ["Manual"],
                filterComponent: SearchSelectWithList(stateDataApi?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),
                overrideFilterAccessor: "state",
                overrideFilterLabel: "State",
            }],
        },
        {
            label: "Manual",
            accessor: "manual",
            canSort: false,
            visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: SearchSelectWithList(getAllCountyByStateAbbrApiResponse?.data, "countyName", "id", "Select Counties...", true, "counties"),
                onDependencyUpdated: (value: any) => {
                    getAllCountyByStateAbbrApi(value);
                },
                overrideFilterAccessor: "counties",
                overrideFilterLabel: "Counties",
            }]
        },
        {
            label: "Manual Updates",
            accessor: "manualUpdate",
            visibility: { hasShowSetting: false },
            canSort: false,
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"}
                />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"}
                />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        },
        {
            label: "Auto", accessor: "auto", visibility: { hasShowSetting: false }, canSort: false,

        },
        {
            label: "Tenant",
            accessor: "tenant",
            overrideSortColumn: "tenant",
            visibility: { canColumnShow: true },
            filterOptions: [{
                dependentColumns: ["product"],
                filterComponent: SearchSelectWithList(tenantData?.data, (tenant: { name: any; }) => `${tenant.name}`, "name", "Select Tenant...", false, "tenant"),
                overrideFilterAccessor: "tenant",
            }],
        },
        {
            label: "Auto Updates",
            accessor: "autoUpdate",
            overrideSortColumn: "order_status",
            visibility: { canColumnShow: true },
            canSort: false,
        },
        {
            label: "Percent Auto", accessor: "percentAuto", overrideSortColumn: "percentAuto", canSort: false
        }
    ];

    const customFilter = {
        createdDateFrom: formattedStartDate,
        state: "TX"
    }

    return (
        <>
            <div className="user-container px-4 py-2">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <ReportType type={type} setType={setType} />
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchAutoVsManualReportApiQuery,
                        exportAction: triggerExportReportDataQuery
                    }
                    }
                    defaultSortOptions={{
                        accessor: "creation_date",
                        direction: "asc"
                    }}
                    defaultFilter={
                        {
                            ...customFilter,

                            "pageNumber": 0,
                            "pageSize": "15",

                        }
                    }
                    userSettingGroup={"Report Auto Vs Manual"}
                    basePermission={"AUTMUNREPO"}
                />
            </div>
            <div />
        </>
    )
}

export default AutoVsManualReport;